import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';

import StockOutReqPdfComponent from './StockOutReqPdfComponent';
import PrintStockOutReq from './PrintStockOutReq';
import { useSelector } from 'react-redux';
import { use } from 'react';
export default function GenPDFpageActionImpl(){
    const {stockoutreqObj}= useSelector((state)=>state.manufslice.stockoutreqDashboard);
    return (
        <>
        {/* <StockOutReqPdfComponent stockoutReqObj={stockoutreqObj}/> */}
        <PrintStockOutReq/>
        </>
    )
}